import { useCallback, useState } from "react";

import { RegisterData, RegisterUIProps } from "./Register.types";

import { useLoginContext } from "../../views/Login/Login.context.tsx";

export const useRegister = (): RegisterUIProps => {
  const { onRegister } = useLoginContext();

  const [validated, setValidated] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [formData, setFormData] = useState<RegisterData>({
    name: "",
    company: "",
    email: "",
    password: "",
    confirmPassword: "",
    phone: "",
    country: "México",
    countryCode: "+52",
  });

  const [selected, setSelected] = useState<{ name: string; code: string }>({
    name: "México",
    code: "+52",
  });

  const handleShowPassword = useCallback(() => setShowPassword((prev) => !prev), []);
  const handleShowConfirmPassword = useCallback(() => setShowConfirmPassword((prev) => !prev), []);

  const handleSelected = useCallback((country: { name: string; code: string }) => {
    setSelected(country);

    setFormData((prev) => ({
      ...prev,
      country: country.name,
      countryCode: country.code,
    }));
  }, []);

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  }, []);

  const handleSubmit = useCallback(
    async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      setValidated(true);

      if (formData.password !== formData.confirmPassword) {
        return;
      }

      if (!e.currentTarget.checkValidity()) {
        return;
      }

      await onRegister(formData);
    },
    [formData, onRegister]
  );

  return {
    formData,
    validated,
    showPassword,
    showConfirmPassword,
    handleShowPassword,
    handleShowConfirmPassword,
    handleSubmit,
    handleChange,
    handleSelected,
    selected,
  };
};
